import { IMAGES } from "../constants/images";
import { useState, useEffect } from 'react';
import { ROUTES } from "../App";
import useMoveTo from "../constants/navigation";

const Entrance = () => {
  const navigate = useMoveTo();
  const [currentSlide, setCurrentSlide] = useState(0);

  const ONBOARDINGLIST = [
    {
      image: IMAGES.onBoarding1,
      title: 'Sell Your Digital Products',
      desc: 'Advertise and sell your digital products using Zylen',
    },
    {
      image: IMAGES.onBoarding2,
      title: 'Build Your Community.',
      desc: 'Create communities and get in touch with like-minded people',
    }
  ];

  const goToNext = () => {
    if (currentSlide === ONBOARDINGLIST.length - 1) {
      localStorage.setItem("isNotFirstTime", true);
      navigate(ROUTES.SIGN_IN, { replace: true });
    } else {
      setCurrentSlide(prev => prev + 1);
    }
  };

  const goToPrev = () => {
    setCurrentSlide(prev => (prev === 0 ? 0 : prev - 1));
  };

  const isLastSlide = currentSlide === ONBOARDINGLIST.length - 1;
  const isFirstSlide = currentSlide === 0;

  return (
    <div className="bg-main w-full relative overflow-hidden main-container ">
      {/* Centered Content */}
      <div className="flex flex-col items-center justify-center text-center pt-20 px-4 md:px-8">
        <img
          src={ONBOARDINGLIST[currentSlide].image}
          className="mb-8 max-h-[250px] md:max-h-[350px] object-contain w-full"
          alt="Onboarding illustration"
        />

        <h3 className="text-2xl md:text-4xl dark:text-white font-bold mb-4 px-2 max-w-xl text-black">
          {ONBOARDINGLIST[currentSlide].title}
        </h3>
        <p className="text-base md:text-lg dark:text-white mb-8 max-w-md mx-auto px-2 text-gray-700">
          {ONBOARDINGLIST[currentSlide].desc}
        </p>
      </div>

      {/* Bottom Navigation */}
      <div className="fixed bottom-10 left-0 right-0 px-4">
        <div className="flex justify-between items-center max-w-screen-md mx-auto w-full">
          {/* Skip / Previous */}
          <button
            onClick={isFirstSlide ? () => {
              localStorage.setItem("isNotFirstTime", true);
              navigate(ROUTES.SIGN_IN)
            } :
              goToPrev
            }
            className="px-4 py-2"
          >
            <p className="text-base md:text-xl dark:text-white opacity-80 text-black">
              {isFirstSlide ? 'Skip' : 'Previous'}
            </p>
          </button>

          {/* Slide Indicators */}
          <div className="flex space-x-2">
            {ONBOARDINGLIST.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${index === currentSlide ? 'dark:bg-white bg-black' : 'dark:bg-white opacity-20 bg-black'
                  }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>

          {/* Next / Finish */}
          <button onClick={goToNext} className="px-4 py-2">
            <p className="text-base md:text-xl text-primary">
              {isLastSlide ? 'Finish' : 'Next'}
            </p>
          </button>
        </div>
      </div>
    </div>

  );
};

export default Entrance;